// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1B44N","event":"_1p6BU","eventDescription":"_5sPHP","eventImage":"_3vZ7V"};